module.exports = __webpack_public_path__ + "img/alibaba.ef6cd722.jpg";